<template>
  <div class="auth-form-container">
    <div class="container mt-3">
      <div class="auth-form-container-card card p-2">
        <div class="row">
          <div class="col-lg-6 col-sm-12 ">
            <slot></slot>
          </div>

          <div class="col-lg-6" :class="imageParentClass" >
            <img :src="image" v-if="image != null" :alt="findAttributeOnSiteInfo('site_name')[0]"
                 class="card-img w-100 h-100 auth-form-container-image">
            <div v-else class="card-img w-100 h-100">
              <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M5 7C5 4.23858 7.23858 2 10 2C12.7614 2 15 4.23858 15 7C15 9.76142 12.7614 12 10 12C7.23858 12 5 9.76142 5 7ZM10 4C8.34315 4 7 5.34315 7 7C7 8.65685 8.34315 10 10 10C11.6569 10 13 8.65685 13 7C13 5.34315 11.6569 4 10 4Z"
                      fill="#000"/>
                <path
                    d="M4.00242 20C4.07771 17.7781 5.90263 16 8.14286 16H9C9.55228 16 10 15.5523 10 15C10 14.4477 9.55228 14 9 14H8.14286C4.75025 14 2 16.7503 2 20.1429C2 21.1685 2.83147 22 3.85714 22H10C10.5523 22 11 21.5523 11 21C11 20.4477 10.5523 20 10 20H4.00242Z"
                    fill="#000"/>
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M17 22C19.7614 22 22 19.7614 22 17C22 14.2386 19.7614 12 17 12C14.2386 12 12 14.2386 12 17C12 19.7614 14.2386 22 17 22ZM17.0303 19.0303L19.5303 16.5303C19.8232 16.2374 19.8232 15.7626 19.5303 15.4697C19.2374 15.1768 18.7626 15.1768 18.4697 15.4697L16.5 17.4393L16.0303 16.9697C15.7374 16.6768 15.2626 16.6768 14.9697 16.9697C14.6768 17.2626 14.6768 17.7374 14.9697 18.0303L15.9692 19.0298C16.2621 19.3227 16.7374 19.3232 17.0303 19.0303Z"
                      fill="#000"/>
              </svg>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AuthenticationFormsContainer",
  props: {
    image: {
      type: String,
      default: null
    },
    imageParentClass: {
      type: String,
      default: 'd-none d-lg-block',
    }
  }
};
</script>
<style scoped>

</style>